import DatePicker, { registerLocale } from 'react-datepicker';
import { useTranslation } from 'react-i18next';

import ru from 'date-fns/locale/ru';

import 'react-datepicker/dist/react-datepicker.css';
import styles from './HistoryDatePicker.module.scss';
import moment from 'moment';
import { useCallback, useMemo } from 'react';
import i18n from 'i18next';
import { useAppSelector } from 'app/store/store';
import { Icon } from '../Icon';

interface Props {
  setDate: React.Dispatch<React.SetStateAction<Date>>;
  onDateSelect: (date: string) => void;
  selected: Date;
}
export const HistoryDatePicker = ({ setDate, selected, onDateSelect }: Props) => {
  const { t } = useTranslation();
  const profile = useAppSelector((state) => state.userSlice.profile);
  const timeFormat: string = useMemo(() => profile?.ui?.['timeFormat'] || 'HH:mm:ss', [profile]);

  registerLocale('ru', ru);

  const timeFormatPicker = useMemo(() => {
    if (timeFormat.slice(0, 2) === 'hh') {
      return `${timeFormat.slice(0, 5)} aa`;
    } else {
      return `${timeFormat.slice(0, 5)}`;
    }
  }, [timeFormat]);

  const dateFormatPicker = useMemo(() => `dd.MM.yyyy, ${timeFormatPicker}`, [timeFormatPicker]);
  const dateFormat = useMemo(() => `YYYY-MM-DDT${timeFormat}Z`, [timeFormat]);

  const addHour = useCallback(() => {
    const newDate = moment(selected).utc().add(1, 'hour').format('YYYY-MM-DDTHH:mm:ssZ');
    setDate(moment(selected).utc().add(1, 'hour').toDate());
    onDateSelect(newDate);
  }, [setDate, selected, onDateSelect]);

  const backHour = useCallback(() => {
    const newDate = moment(selected).locale('en').utc().add(-1, 'hour').format('YYYY-MM-DDTHH:mm:ssZ');
    setDate(moment(selected).utc().add(-1, 'hour').toDate());
    onDateSelect(newDate);
  }, [setDate, selected, onDateSelect]);

  const minDate = moment().utc().startOf('year').toDate();
  const maxDate = moment().utc().toDate();
  const canGoForward = useMemo(
    () => moment(selected).utc().add(1, 'hour').toDate().getTime() < maxDate.getTime(),
    [selected, maxDate],
  );
  const canGoBack = useMemo(
    () => moment(selected).utc().add(-1, 'hour').toDate().getTime() > minDate.getTime(),
    [selected, minDate],
  );

  const passedTime = (time: any) => {
    const currentDate = new Date();
    const selectedDate = new Date(time);

    return currentDate.getTime() > selectedDate.getTime();
  };

  return (
    <div className={styles.date_picker}>
      <div>{t('DatePickerLabel')}</div>
      <DatePicker
        wrapperClassName={styles.date_picker_wrapper}
        popperClassName={styles.date_picker_popper}
        locale={i18n.language}
        showPopperArrow={false}
        selected={selected}
        onChange={(date: Date) => setDate(date)}
        showTimeSelect
        timeCaption={t('DatePickerTimeCaption')}
        monthClassName={() => styles.header}
        timeIntervals={30}
        placeholderText={t('DatePickerPlaceholderText')}
        dateFormat={dateFormatPicker}
        minDate={minDate}
        maxDate={maxDate}
        //НЕльзя поменять локаль
        timeFormat={timeFormatPicker}
        onCalendarClose={() => {
          const timestamp = moment(selected).utc().format(dateFormat);
          onDateSelect(timestamp);
        }}
        filterTime={passedTime}
      />

      <div className={styles.buttons}>
        <Icon name="pagination-arrow-left" size="12" onClick={backHour} aria-disabled={!canGoBack} />
        <Icon name="pagination-arrow-right" size="12" onClick={addHour} aria-disabled={!canGoForward} />
      </div>
    </div>
  );
};
